module.exports = __webpack_public_path__ + "img/capentry.223cbfdb.jpg";